module.exports = __webpack_public_path__ + "img/iZettleGo.14adfa0f.svg";